<template>
    <div v-if="visivel" class="is-flex is-flex-direction-column">
        <div v-if="exibeBtnVoltar" 
            class="has-text-right">
            <button @click="btnVoltar()" type="button" class="button">
                Voltar
            </button>
        </div>
        <div class="is-12 comum-nenhuma-informacao-disponivel has-text-centered" style="background-color: #fff; padding: 15px 0 35px;">
            <h3 class="texto-card" v-html="textoCard"></h3>

            <div v-if="!escondeBotoes && (!cbEsconde || !cbSecundariaEsconde)">
                <br>
            </div>

            <button type="button" class="button"
                    v-if="!escondeBotoes && !cbEsconde"
                    @click="cb()">{{btnNome}}</button>

            <button type="button" class="button ml-2"
                    v-if="!!btnNomeSecundario.length && !escondeBotoes && !cbSecundariaEsconde"
                    @click="cbSecundaria()">{{btnNomeSecundario}}</button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'NenhumaInformacao',
    props: {
       visivel: {
           type: Boolean,
           require:true
       },
       cb: {
            type: Function,
            required: false,
       },
       btnVoltar: {
            type: Function,
            required: false,
       },
       exibeBtnVoltar: {
            type: Boolean,
            default: false,
            required: false,
       },
       cbEsconde: {
            type: Boolean,
            default: false,
            required: false
       },
       btnNome: {
           type: String,
           default: '',
           require: false
       },
       cbSecundaria: {
            type: Function,
            required: false,
       },
       cbSecundariaEsconde: {
            type: Boolean,
            default: false,
            required: false
       },
       btnNomeSecundario: {
           type: String,
           default: '',
           require: false
       },
       escondeBotoes: {
            type: Boolean,
            default: false,
            required: false
       },
       textoCard: {
           type: String,
           default: 'Nenhuma informação disponível',
           require: false
       }
    }
};
</script>

<style lang="scss" scoped>

.comum-nenhuma-informacao-disponivel {
    margin-top: 20px;
    border: 1px solid rgba(51, 51, 51, 0.2);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    
    .texto-card {
        color: #777;
        text-align: center;
        font-size: 20px;
        margin-top: 20px;
        margin-bottom: 10px;
    }
}



</style>